import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

const styles = (theme: Theme) => ({
    textField: {
        marginLeft: theme.typography.pxToRem(8),
        marginRight: theme.typography.pxToRem(8),
        width: '100%',
    },
});


interface SearchProps extends WithStyles<typeof styles>, WrappedComponentProps {
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>;
    placeholder?: string;
    id?: string;
    value?: Array<string | number | boolean> | string | number | boolean;
}

const Search = ({ classes, onChange, placeholder, id, value }: SearchProps) => (
    <Grid id="yeself-textField" item>
        <TextField
            value={value}
            id={id}
            placeholder={placeholder}
            type="search"
            onChange={onChange}
            className={classes.textField}
            margin="normal"
        />
    </Grid>
);

export default withStyles(styles)(injectIntl(Search));
